import PolySans from './fonts/PolySans-Median.otf';
import MatterRegular from './fonts/Matter-Regular.woff2';

export default {
    headerFont: PolySans,
    readableFont: MatterRegular,
};
